import {
  ApplicationRef,
  EnvironmentInjector,
  createComponent,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
  Type
} from '@angular/core';
import {Router} from '@angular/router';
import {DialogConfig} from '../components/dialog/dialog-config';
import {DialogInjector} from '../components/dialog/dialog-injector';
import {DialogRef} from '../components/dialog/dialog-ref';
import {DialogComponent} from '../components/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  dialogComponentRef?: ComponentRef<DialogComponent>;

  constructor(
    private applicationRef: ApplicationRef,
    private injector: Injector,
    private environmentInjector: EnvironmentInjector,
    private router: Router
  ) { }

  public open(componentType: Type<unknown>, dialogConfig: DialogConfig) {
    const dialogRef = this.appendDialogComponentToBody(dialogConfig, componentType);
    return dialogRef;
  }

  private appendDialogComponentToBody(config: DialogConfig, componentType?: Type<unknown>) {
    if (this.dialogComponentRef) {
      this.removeDialogComponentFromBody();
    }
    // create a map with the config
    const map = new WeakMap();
    map.set(DialogConfig, config);

    // add the DialogRef to dependency injection
    const dialogRef = new DialogRef();
    map.set(DialogRef, dialogRef);

    // we want to know when somebody called the close method
    const sub = dialogRef.afterClosed.subscribe(() => {
      // close the dialog
      this.removeDialogComponentFromBody();
      sub.unsubscribe();
    });

    // use our new injector
    const customInjector = new DialogInjector(this.injector, map);

    // create the DialogComponent with the custom injector
    const componentRef = createComponent(DialogComponent, {
      environmentInjector: this.environmentInjector,
      elementInjector: customInjector
    });

    // IMPORTANT: set child component type and any data BEFORE attaching the view
    if (componentType) {
      // set the type so DialogComponent.ngAfterViewInit can load it
      componentRef.instance.childComponentType = componentType;
    }

    // also expose data on the dialog host instance so loadChildComponent can use Object.assign
    if (config?.data !== undefined) {
      componentRef.instance.data = config.data;
    }

    // attach view and add to DOM
    this.applicationRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<unknown>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    this.dialogComponentRef = componentRef;

    this.closeDialogIfRoutChanged();

    this.dialogComponentRef.instance.onClose.subscribe(() => {
      this.removeDialogComponentFromBody();
    });

    return dialogRef;
  }


  private closeDialogIfRoutChanged(): void {
    const sub = this.router.events.subscribe(() => {
      this.removeDialogComponentFromBody();
      sub.unsubscribe();
    });
  }

  private removeDialogComponentFromBody() {
    if (this.dialogComponentRef) {
      this.applicationRef.detachView(this.dialogComponentRef.hostView);
      this.dialogComponentRef.destroy();
      this.dialogComponentRef = undefined;
    }
  }




}
